module.exports = __webpack_public_path__ + "img/issuance-step-2.9857f94a.png";